<script>
  import cookieManager from '@/libs/cookie-manager'
  import Page from '@/containers/Page/Page'
  import MessageBar from '@/components/MessageBar/MessageBar'
  import Hero from '@/components/Hero/Hero'
  import SuccessStories from '@/components/SuccessStories/SuccessStories'
  import HowItWorks from '@/components/HowItWorks/HowItWorks'
  import SampleQuestions from '@/components/SampleQuestions/SampleQuestions'
  import SampleSolution from '@/components/SampleSolution/SampleSolution'

  import Modal from '@/components/Modal/Modal'
  import EnterEmailButton from '@/components/EnterEmailButton/EnterEmailButton'

  import './style.scss'

  export default {
    name: 'lander',
    components: {
      MessageBar,
      Hero,
      HowItWorks,
      Modal,
      Page,
      SampleQuestions,
      SuccessStories,
      EnterEmailButton,
      SampleSolution,
    },
    created() {
      if (this.$route.query.ref) {
        // pramp did this fucked up shit
        if (this.$route.query.ref === 'pramp ') {
          cookieManager.setRef('pramp')
        } else {
          console.log('hello')
          cookieManager.setRef(this.$route.query.ref)
        }
      }
    }
  }
</script>

<template>
  <Page class='lander'>
    <MessageBar />
    <Hero />
    <HowItWorks />
    <SampleQuestions />
    <SampleSolution />
    <SuccessStories />
    <EnterEmailButton />
    <br>
    <br>
    <br>
  </Page>
</template>



// WEBPACK FOOTER //
// src/flows/Lander/Lander.vue